import { Button } from "@/components/ui/button";
import { Dumbbell, Timer, Heart, Brain, Scale, Users, List, Activity, ChevronDown } from "lucide-react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useEffect, useState } from "react";
import { useMediaQuery } from "../hooks/use-media-query";

interface CategoryFilterProps {
  categories: { id: string, name: string }[];
  selectedCategoryIds: string[];
  onSelectCategory: (categoryId: string) => void;
}

// Map of category names to icons
const categoryIcons: Record<string, any> = {
  "Strength Training": Dumbbell,
  "Cardio & Running": Activity,
  "Workout Planning": Timer,
  "Health & Nutrition": Heart,
  "Mindfulness & Yoga": Brain,
  "Progress Tracking": Scale,
  "Personal Training": Users,
  "Activity Logging": List,
};

const CategoryFilter = ({ categories, selectedCategoryIds, onSelectCategory }: CategoryFilterProps) => {
  const isDesktop = useMediaQuery("(min-width: 1024px)");
  const [value, setValue] = useState<string | undefined>(isDesktop ? "categories" : undefined);

  useEffect(() => {
    setValue(isDesktop ? "categories" : undefined);
  }, [isDesktop]);

  return (
    <Accordion 
      type="single" 
      value={value} 
      onValueChange={setValue}
      collapsible
    >
      <AccordionItem value="categories" className="border-none">
        <AccordionTrigger className="hover:no-underline">
          <h2 className="text-xl font-semibold">Categories</h2>
        </AccordionTrigger>
        <AccordionContent>
          <div className="space-y-2 pt-2">
            {categories.map((category) => {
              const IconComponent = categoryIcons[category.name] || Activity;
              const isSelected = selectedCategoryIds.includes(category.id);
              
              return (
                <Button
                  key={category.id}
                  variant={isSelected ? "default" : "ghost"}
                  className="w-full justify-start"
                  onClick={() => onSelectCategory(category.id)}
                >
                  <IconComponent className="mr-2 h-4 w-4" />
                  {category.name}
                </Button>
              );
            })}
            
            {selectedCategoryIds.length > 0 && (
              <Button
                variant="outline"
                className="w-full justify-center mt-2 text-xs"
                onClick={() => selectedCategoryIds.forEach(id => onSelectCategory(id))}
              >
                Clear All Filters
              </Button>
            )}
          </div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};

export default CategoryFilter;
